"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiIconButtonStyles = exports.primaryIconColor = exports.disabledIconColor = exports.focusedBGColor = exports.hoveredBGColor = exports.iconColor = void 0;
var component_2023_utils_token_parser_1 = require("@rentspree/component-2023.utils.token-parser");
exports.iconColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.icon.color');
exports.hoveredBGColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.hovered.state-layer.color');
exports.focusedBGColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.focused.state-layer.color');
exports.disabledIconColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.disabled.icon.color');
exports.primaryIconColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.primary.icon.color');
var hoveredPrimaryBGColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.primary.hovered.state-layer.color');
var focusedPrimaryBGColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.primary.focused.state-layer.color');
exports.muiIconButtonStyles = {
    styleOverrides: {
        root: {
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.state-layer.height'),
            width: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.state-layer.width'),
            borderRadius: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.state-layer.shape'),
            color: exports.primaryIconColor,
            ':hover': {
                backgroundColor: hoveredPrimaryBGColor,
            },
            ':focus': {
                backgroundColor: focusedPrimaryBGColor,
            },
            '& .MuiSvgIcon-root': {
                fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.icon.size'),
            },
            '&.Mui-disabled.MuiIconButton-root': {
                color: exports.disabledIconColor,
            },
            '&.RSPIconButton-colorwhite': {
                color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.white.icon.color'),
                ':hover': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.white.hovered.state-layer.color'),
                },
                ':focus': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.white.focused.state-layer.color'),
                },
                ':disabled': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.white.disabled.icon.color'),
                },
            },
            '&.RSPIconButton-colorblack': {
                color: exports.iconColor,
                ':hover': {
                    backgroundColor: exports.hoveredBGColor,
                },
                ':focus': {
                    backgroundColor: exports.focusedBGColor,
                },
            },
        },
        sizeSmall: {
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.small.state-layer.height'),
            width: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.small.state-layer.width'),
            '& .MuiSvgIcon-root': {
                fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.icon-button.small.icon.size'),
            },
        },
    },
};
//# sourceMappingURL=icon-button.js.map